var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import React, { useEffect, useState } from 'react';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { PopupContainer } from 'src/common-ui/popup-container/popup-container.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import Config from 'src/config';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const TutorialPopup = () => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        init();
    }, []);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        const skipTutorial = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.SKIP_TUTORIAL);
        if (!skipTutorial) {
            setShow(true);
        }
    });
    const handleClick = (option) => __awaiter(void 0, void 0, void 0, function* () {
        if (option === 'show') {
            chrome.tabs.create({
                url: `${Config.tutorial.baseUrl}`,
            });
        }
        yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.SKIP_TUTORIAL, true);
        setShow(false);
    });
    // if (!show) return null;
    return null;
    return (React.createElement(PopupContainer, { "data-testid": "tutorial-popup", className: "tutorial" },
        React.createElement("div", { className: "popup-title" }, getMessage('popup_html_tutorial_popup_title')),
        React.createElement(SVGIcon, { className: "image", icon: SVGIcons.KEYCHAIN_LOGO_SPLASHSCREEN }),
        React.createElement("div", { className: "sub-title", dangerouslySetInnerHTML: {
                __html: getMessage('popup_html_tutorial_popup_description'),
            } }),
        React.createElement("div", { className: "popup-footer" },
            React.createElement("div", { className: "buttons-container" },
                React.createElement(ButtonComponent, { label: "popup_html_tutorial_popup_skip_label", type: ButtonType.ALTERNATIVE, onClick: () => handleClick('skip'), additionalClass: "button" }),
                React.createElement(ButtonComponent, { label: "popup_html_tutorial_popup_show_label", type: ButtonType.IMPORTANT, onClick: () => handleClick('show'), additionalClass: "button" })))));
};
export const TutorialPopupComponent = TutorialPopup;
